import { render, staticRenderFns } from "./RolesSettingsPage.vue?vue&type=template&id=08c3caf2&"
import script from "./RolesSettingsPage.vue?vue&type=script&lang=js&"
export * from "./RolesSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports